import { Flex, Box, Text, Textarea, Spinner, Button } from "@chakra-ui/react";
import {
  useGetDifferentialDiagnosis,
  useSaveDifferentialProvisionalDiagnosis,
  useGetLatestProvisionalDifferentialDiagnosis,
} from "../../../apis/patients";
import colors from "../../../utils/colors";
import { useState } from "react";

interface DifferentialDiagnosisProps {
  appointmentId: string;
}

const DifferentialDiagnosis: React.FC<DifferentialDiagnosisProps> = ({
  appointmentId,
}) => {
  const { data, isLoading, error } = useGetDifferentialDiagnosis(appointmentId);
  const {
    mutate,
    isPending: isSaving,
    isError,
  } = useSaveDifferentialProvisionalDiagnosis();

  const [provisionalDiagnosis, setProvisionalDiagnosis] = useState("");

  const { data: LatestProvisionalDiagnosis } =
    useGetLatestProvisionalDifferentialDiagnosis(appointmentId || "");

  const causes = data?.data?.causes || [];

  const handleSubmit = () => {
    if (!provisionalDiagnosis.trim()) return;

    mutate(
      {
        appointmentId,
        differentialDiagnosis: causes,
        provisionalDiagnosis,
      },
      {
        onSuccess: () => setProvisionalDiagnosis(""),
      }
    );
  };

  return (
    <Flex direction="column" width="100%" gap="20px">
      <Box
        backgroundColor="white"
        borderRadius="8px"
        boxShadow="1px 4px 15px 0px #3030301F"
        padding="40px"
      >
        <Text fontSize="16px" fontWeight={700} color={colors.dark} mb="12px">
          Differential Diagnosis
        </Text>

        {isLoading ? (
          <Spinner size="lg" color={colors.primary} />
        ) : error || causes.length === 0 ? (
          <Text>No differential diagnosis found</Text>
        ) : (
          <Box>
            {causes.map((cause: string) => (
              <Text
                key={cause}
                fontSize="14px"
                fontWeight={500}
                color={colors.dark}
              >
                {cause}
              </Text>
            ))}
          </Box>
        )}
      </Box>

      <Box
        backgroundColor="white"
        borderRadius="8px"
        boxShadow="1px 4px 15px 0px #3030301F"
        padding="40px"
      >
        <Text fontSize="16px" fontWeight={700} color={colors.dark} mb="12px">
          Provisional Diagnosis:{" "}
          {LatestProvisionalDiagnosis?.data?.provisionalDiagnosis ||
            "No provisional diagnosis yet"}
        </Text>

        <Textarea
          focusBorderColor={colors.primary}
          placeholder="Enter provisional diagnosis"
          value={provisionalDiagnosis}
          onChange={(e) => setProvisionalDiagnosis(e.target.value)}
        />

        <Flex justifyContent="flex-end">
          <Button
            colorScheme="green"
            mt="20px"
            isLoading={isSaving}
            onClick={handleSubmit}
          >
            Submit
          </Button>
        </Flex>

        {isError && (
          <Text color="red.500" mt="10px">
            Failed to save diagnosis. Please try again.
          </Text>
        )}
      </Box>
    </Flex>
  );
};

export default DifferentialDiagnosis;
